// API認証トークン管理ユーティリティ

class TokenManager {
  constructor() {
    this.token = null;
    this.tokenExpiry = null;
    this.tokenEndpoint = '/api/token.php'; // デフォルトのエンドポイント
  }

  // トークンエンドポイントを設定
  setTokenEndpoint(endpoint) {
    this.tokenEndpoint = endpoint;
    // エンドポイントが変更されたらキャッシュをクリア
    this.clearToken();
  }

  // 現在のトークンエンドポイントを取得
  getTokenEndpoint() {
    return this.tokenEndpoint;
  }

  // トークンを取得（必要に応じて新規取得）
  async getToken() {
    // 既存のトークンがまだ有効か確認
    if (this.token && this.tokenExpiry && Date.now() < this.tokenExpiry) {
      return this.token;
    }

    // 新しいトークンを取得
    try {
      const response = await fetch(this.tokenEndpoint, {
        method: 'POST',
        credentials: 'same-origin', // セッションCookieを送信
        headers: {
          'Accept': 'application/json'
        }
      });

      if (!response.ok) {
        throw new Error(`Token fetch failed: ${response.status}`);
      }

      const data = await response.json();

      // OAuth形式のレスポンスを処理
      if (data.access_token) {
        this.token = data.access_token;
        // 有効期限の90%の時点で期限切れとみなす（余裕を持たせる）
        const expiresIn = data.expires_in || 3600; // デフォルト1時間
        this.tokenExpiry = Date.now() + (expiresIn * 1000 * 0.9);
        return this.token;
      } else if (data.error) {
        throw new Error(`Token error: ${data.error.message || data.error.error_id}`);
      } else {
        throw new Error('Invalid token response');
      }
    } catch (error) {
      console.error('トークン取得エラー:', error);
      throw error;
    }
  }

  // トークンをクリア
  clearToken() {
    this.token = null;
    this.tokenExpiry = null;
  }
}

// シングルトンインスタンスをエクスポート
const tokenManager = new TokenManager();
export default tokenManager;
